import { useState, useCallback } from 'react';
import api from '../api';

export function useAgent2() {
  const [agent2History, setAgent2History] = useState([]);
  const [agent2Running, setAgent2Running] = useState(false);
  const [agent2HistoryError, setAgent2HistoryError] = useState(false);

  const fetchAgent2History = useCallback(async () => {
    setAgent2HistoryError(false);
    try {
      const res = await api.get('/agent2/history');
      setAgent2History(Array.isArray(res.data) ? res.data : []);
    } catch {
      setAgent2HistoryError(true);
    }
  }, []);

  const validateBase = useCallback(async () => {
    setAgent2Running(true);
    try {
      const res = await api.post('/exports/master/clean');
      if (res.data?.error) {
        throw new Error(res.data.message || res.data.error);
      }
      await fetchAgent2History();
      return res.data;
    } finally {
      setAgent2Running(false);
    }
  }, [fetchAgent2History]);

  return {
    agent2History,
    agent2Running,
    agent2HistoryError,
    fetchAgent2History,
    validateBase,
  };
}
